import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

interface ComplianceProgressData {
  avg_progress: number;
  quarter: string;
  year: number;
}

interface ComplianceProgressChartProps {
  data: ComplianceProgressData[];
}

const ComplianceProgressChart: React.FC<ComplianceProgressChartProps> = ({ data }) => {
  // Transform data to include quarter-year label and ensure avg_progress is a number
  const chartData = data?.map((item) => ({
    period: `${item.quarter} ${item.year}`,
    progress: parseFloat(item.avg_progress.toString()),
    quarter: item.quarter,
    year: item.year
  }));

  return (
    <div style={{ width: '100%', height: '300px' }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="period" 
            tick={{ fontSize: 12 }}
            angle={-45}
            textAnchor="end"
            height={80}
          />
          <YAxis 
            domain={[0, 100]}
            tick={{ fontSize: 12 }}
            label={{ value: 'Progress (%)', angle: -90, position: 'insideLeft' }}
          />
          <Tooltip 
            formatter={(value: number) => [`${value.toFixed(2)}%`, 'Average Progress']}
            labelFormatter={(label) => `Period: ${label}`}
          />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="progress" 
            stroke="#8884d8" 
            strokeWidth={3}
            dot={{ fill: '#8884d8', strokeWidth: 2, r: 6 }}
            activeDot={{ r: 8 }}
            name="Average Progress"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ComplianceProgressChart; 